import { useState } from 'react'
import { changeAdminPassword } from '@/api/adminApi'
import { AdminPage, AdminPanel } from '@/components/Admin'
import { useSaveFeedback } from '@/hooks/useSaveFeedback'
import styles from './Admin.module.css'

export function AdminContaPage() {
  const [senhaAtual, setSenhaAtual] = useState('')
  const [senhaNova, setSenhaNova] = useState('')
  const [senhaConfirm, setSenhaConfirm] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { notifySaved, notifyError, notifyValidation } = useSaveFeedback()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!senhaAtual.trim()) {
      notifyValidation('Indique a senha actual.')
      return
    }
    if (senhaNova.length < 6) {
      notifyValidation('A nova senha deve ter pelo menos 6 caracteres.')
      return
    }
    if (senhaNova !== senhaConfirm) {
      notifyValidation('A confirmação da nova senha não coincide.')
      return
    }
    setSaving(true)
    setError(null)
    try {
      await changeAdminPassword(senhaAtual, senhaNova)
      setSenhaAtual('')
      setSenhaNova('')
      setSenhaConfirm('')
      notifySaved('Senha alterada com sucesso.')
    } catch (err) {
      notifyError(err, 'Erro ao alterar senha')
      setError(err instanceof Error ? err.message : 'Erro ao alterar senha')
    } finally {
      setSaving(false)
    }
  }

  return (
    <AdminPage
      title="Minha conta"
      subtitle="Altere a senha de acesso ao painel de administrador."
      error={error}
      wide
    >
      <form id="form-conta" className={styles.adminFormStack} onSubmit={handleSubmit}>
        <AdminPanel
          title="Alterar senha"
          description="Use uma senha forte e não a partilhe com terceiros."
          footer={
            <button type="submit" className={styles.btnSalvar} disabled={saving} form="form-conta">
              {saving ? 'A guardar…' : 'Guardar nova senha'}
            </button>
          }
        >
          <div className={styles.formGroup}>
            <label htmlFor="conta-senha-atual">Senha actual</label>
            <input
              id="conta-senha-atual"
              type="password"
              autoComplete="current-password"
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="conta-senha-nova">Nova senha</label>
            <input
              id="conta-senha-nova"
              type="password"
              autoComplete="new-password"
              value={senhaNova}
              onChange={(e) => setSenhaNova(e.target.value)}
              minLength={6}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="conta-senha-confirm">Confirmar nova senha</label>
            <input
              id="conta-senha-confirm"
              type="password"
              autoComplete="new-password"
              value={senhaConfirm}
              onChange={(e) => setSenhaConfirm(e.target.value)}
              minLength={6}
              required
            />
          </div>
        </AdminPanel>
      </form>
    </AdminPage>
  )
}
